// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactNavButton-cls1_SEY","cls2":"ImpactNavButton-cls2_MPb ImpactNavButton-cls1_SEY"};